<template>
  <a-layout class='index animated fadeIn'>
    <div class="s_bf">
      <a-tabs >
        <a-tab-pane key="1" tab="发放明细">
          <grantList></grantList>
        </a-tab-pane>
        <a-tab-pane key="2" tab="使用明细">
          <usedList></usedList>
        </a-tab-pane>
      </a-tabs>
    </div>
  </a-layout>
</template>
<script>
import { ref, onMounted,inject,reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import { iscode } from "@/utils/app";
import usedList from './usedList';
import grantList from './grantList';
export default {
  name:'statistics',
  components: {usedList,grantList },
  setup(props) {
    const state = reactive({

    });
    const $router = inject('$router')
    const $Modal = inject('$Modal')
    const momentTime = inject('momentTime')
    
    onMounted(() => {
    });
    return {
      ...toRefs(state)
    };
  },
};
</script>